export const ANTD_NEW_THEME = {
  token: {
    colorPrimary: '#084B83',
  },
  components: {
    Button: {
      colorLink: '#084B83',
      colorLinkActive: '#3D87C5',
      colorLinkHover: '#3D87C5',
      defaultShadow: 'none',
      primaryShadow: 'none',
      paddingInline: 16,
      contentFontSizeLG: 14,
    },
    Form: {
      itemMarginBottom: 0,
    },
    Tooltip: {
      colorBgSpotlight: '#1F2C4E',
    },
    Modal: {
      margin: 0,
    },
    Input: {
      fontSizeLG: 13,
      fontSize: 13,
    },
    InputNumber: {
      fontSizeLG: 13,
      fontSize: 13,
    },
    DatePicker: {
      fontSizeLG: 13,
      fontSize: 13,
    },
    Select: {
      fontSizeLG: 13,
      fontSize: 13,
      optionSelectedBg: '#DCE7F2',
      optionSelectedColor: '#084B83',
    },
    Tabs: {
      verticalItemMargin: '8px 0 0 0',
      colorBorder: '#DCE7F2',
      colorText: '#303443',
      paddingLG: 12,
      verticalItemPadding: '8px 24px',

      // for the manage account modal
      horizontalMargin: '0',
      colorBorderSecondary: 'none',
    },
    Table: {
      headerBg: '#EEF6FE',
      borderColor: '#D6E3F0',
      headerColor: '#303443',
      rowHoverBg: '#F5F9FF',
    },
    Tag: {
      marginXS: 0,
    },
    Menu: {
      itemSelectedBg: '#CEDEFE',
      // hover for active elements
      itemHoverBg: '#F2F9FF',

      fontSizeLG: 13,
      fontSize: 13,
      colorBgElevated: 'white',
      colorBgContainer: 'transparent',
    },
    Skeleton: {
      gradientFromColor: '#c5e0ff',
      gradientToColor: '#79beff',
      blockRadius: 18,
    },
    Descriptions: {
      labelBg: '#e1f3fd',
    },
  },
}
